import { GenericPageShimmer } from '../../../../../shimmer/GenericPageShimmer/GenericPageShimmer';

export function PipelineCreateSelectDestinationLoadingSkeleton() {
  return (
    <div style={{ marginTop: 200 }}>
      <GenericPageShimmer dataId='pipeline-create' />
    </div>
  );
}
